import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
//import table service
import { TableService } from '../../../core/services/table.service';
import { TableScasService } from 'src/app/core/services/table-scas.service';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';

export interface RowColumnParams {
  index: number;
  column: string;
  unit: object;
}
@Component({
  selector: 'app-mat-table-with-chip',
  templateUrl: './mat-table-with-chip.component.html',
  styleUrls: ['./mat-table-with-chip.component.scss'],
  standalone: false,
})
export class MatTableWithChipComponent implements OnInit, OnChanges, OnDestroy {
  @Input() tableData: object;
  @Input() selectedParamsFromSCAS: boolean;
  @Input() source: boolean;
  @Output() valueToParent: EventEmitter<any> = new EventEmitter();
  @Output() dataToParent: EventEmitter<any> = new EventEmitter();
  // @Output() selectedRowColumn: EventEmitter<RowColumnParams> = new EventEmitter();
  dataSource;
  columnDefs: string[];
  componentType: string;
  selectedIndex: number;
  selectedColumn: string;
  selectedUnit: object;
  selectedParamsObj: RowColumnParams;
  enableChip: boolean = false;
  noTableData: boolean = false;
  headers: string[];
  data = {
    // Required
    type: 'mattablechip component', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: 'mattablechip', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '1', //Required.  Unique page id
    itype: 'click', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };

  constructor(
    private _telemetryServices: TelemetryServices,
    private _tableService: TableService,
    private paramTable: TableScasService,
  ) {}

  ngOnChanges() {
    this.assignTableData();
  }

  ngOnInit() {
    // telemtry  API CALL and, send data

    this._tableService.setCandidateID({});

    this.data.type = 'mat-table-with-chip component';
    this.data.subtype = 'mat-table-with-chip';
    this.data.pageid = '1';
    this.data.itype = 'AUTO';
    this.data.stageto = 'initial mat-table loading';
    if (this.data) {
      // this._telemetryServices.telemetryImpression(this.data);
    }
  }

  assignTableData() {
    if (this.tableData === null) {
      this.noTableData = false;
    } else if (
      (this.tableData['ELEMENT_DATA'] &&
        (this.tableData['ELEMENT_DATA'].length == 0 ||
          (this.tableData['ELEMENT_DATA'][0]['unit'] &&
            this.tableData['ELEMENT_DATA'][0]['unit'].toLowerCase() == 'total'))) ||
      (Object.keys(this.tableData).length === 0 && this.tableData.constructor === Object)
    ) {
      console.log('inside if mat');
      this.noTableData = true;
    } else {
      this.noTableData = false;
      for (const data in this.tableData) {
        if (data === 'ELEMENT_DATA') {
          this.dataSource = [];
          setTimeout(() => {
            this.dataSource = this.tableData[data];
          }, 200);
        } else if (data === 'headers') {
          this.columnDefs = [];
          setTimeout(() => {
            this.columnDefs = this.tableData[data];
            this.headers = this.tableData[data].map((el, _i) => {
              if (el.includes('_')) {
                return el.replace(/_/g, ' ');
              } else {
                return el;
              }
            });

            if (this.selectedParamsFromSCAS) {
              console.log(this.selectedParamsFromSCAS);
              if (
                this.columnDefs &&
                this.dataSource &&
                this.dataSource[0]['unit'] &&
                this.dataSource[0]['unit'].toLowerCase() != 'total' &&
                this.componentType != 'validate'
              ) {
                this.paramTable.getParams().subscribe((res) => {
                  this.selectedParamsObj = res;
                });
                this.showCandidates(
                  this.selectedParamsObj.index,
                  this.selectedParamsObj.column,
                  this.selectedParamsObj.unit,
                );
              }
            } else {
              if (this.source) {
                console.log('call---------');
                console.log(this.columnDefs);
                console.log(this.dataSource[0]['name']);
                if (
                  this.columnDefs &&
                  this.dataSource &&
                  this.dataSource[0]['name'] &&
                  this.dataSource[0]['name'].toLowerCase() != 'total' &&
                  this.dataSource[0]['name'].toLowerCase() != 'processed' &&
                  this.componentType != 'validate'
                ) {
                  this.showCandidates(0, this.columnDefs[1], this.dataSource[0]);
                }
              }
              if (
                this.columnDefs &&
                this.dataSource &&
                this.dataSource[0]['unit'] &&
                this.dataSource[0]['unit'].toLowerCase() != 'total' &&
                this.componentType != 'validate'
              ) {
                console.log('call---------');
                this.showCandidates(0, this.columnDefs[1], this.dataSource[0]);
              }
            }
          }, 200);
        } else {
          this.componentType = this.tableData[data];
        }
      }
    }
    console.log(this.tableData);
  }

  // click method to show candidates
  showCandidates(index: number, columnName: string, unit: object) {
    //console.log(index);
    // console.log(columnName);
    // console.log(unit);
    // if(unit["unit"] != 'total'){
    if (event) {
      event.stopPropagation();
    }
    this.selectedIndex = index;
    this.selectedColumn = columnName;
    this.selectedUnit = unit;
    this.selectedParamsObj = {
      index: this.selectedIndex,
      column: this.selectedColumn,
      unit: this.selectedUnit,
    };
    this.paramTable.setParams(this.selectedParamsObj);
    // this.selectedRowColumn.emit(this.selectedParamsObj);

    if (columnName === this.selectedColumn && index === this.selectedIndex) {
      this.enableChip = true;
      if (this.enableChip) {
        // event emitter to pass data; passing index and respective column
        this.valueToParent.emit(unit[columnName]['ids']);
        this.dataToParent.emit({
          id: unit[columnName],
          componentName: this.componentType,
          type: columnName,
          name: unit['name'],
        });
        //console.log(unit);
        console.log('table', unit[columnName], columnName, unit['name']);

        // injecting/setting in table service
        this._tableService.setCandidateID({
          id: unit[columnName],
          componentName: this.componentType,
          type: columnName,
          name: unit['name'],
        });
      }
    }

    // }
  }

  // show value and chip methods
  removeChip(index: number, columnName: string, unit: object) {
    if (event) {
      event.stopPropagation();
    }

    if (index === this.selectedIndex && columnName === this.selectedColumn) {
      this.enableChip = false;
      console.log(unit);
      console.log(columnName);
      // this.valueToParent.emit([unit[columnName]]);
      this.valueToParent.emit([]);
      this.dataToParent.emit([]);
      console.log('data--' + JSON.stringify(unit[columnName]));
      this._tableService.setCandidateID({
        id: { ids: [], count: 0 },
        componentName: this.componentType,
        type: columnName,
        name: unit['name'],
      });

      // this.valueToParent.emit()
    }
  }
  ngOnDestroy() {
    // telemtry end call

    this.data.type = 'mat-table-with-chip component';
    this.data.subtype = 'mat-table-with-chip cleanup stage/end of page';
    this.data.pageid = '1';
    this.data.itype = 'AUTO';
    this.data.stageto = 'destroy component,initial page';
    if (this.data) {
      // this._telemetryServices.telemetryEnd(this.data);
    }
  }
}
